import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve } from "@angular/router";
import { Observable } from "rxjs";
import { AtualizacoesAuditService } from "../services/atualizacoes-audit.service";
import { ExecucaoOrcamentariaService } from "../services/execucao-orcamentaria.service";

@Injectable({
  providedIn: 'root'
})
export class ExecucaoOrcamentariaResolver implements Resolve<boolean> {

  constructor(private service: ExecucaoOrcamentariaService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.parent.parent.params.idProjeto);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ExecucaoOrcamentariaPermissionResolver implements Resolve<boolean> {

  constructor(private service: ExecucaoOrcamentariaService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getPermission(route.params.id);
  }
}

@Injectable({
  providedIn: 'root'
})
export class ExecucaoOrcamentariaAuditoriaResolver implements Resolve<boolean> {

  constructor(private service: AtualizacoesAuditService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    let audit = {
      budget_id: route.params.id,
      budget_assoc_fpe_id: route.params.id,
    };
    return this.service.getAtualizacoes(audit);
  }
}